import { Injectable, Pipe, PipeTransform } from '@angular/core';

// busca url en un texto y le añade el enlace
// Para usarlo hay que meter el texto en un innerHtml.
// Por ejemplo: <div [innerHtml]="texto | techUrlify "></div>

@Pipe({ name: 'trUrlify' })
@Injectable({ providedIn: 'root' })
export class UrlifyPipe implements PipeTransform {
  transform(text: any): any {
    const urlRegex =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return text.replace(urlRegex, (url) => {
      return '<a target="_blank" href="' + url + '">' + url + '</a>';
    });
  }
}
